module.exports = {
  form: {
    write_num: null,
    data: []
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/subform.js